function ConfigManager() {
  // this.APIRoot = "https://localhost:7072/api";
  this.ApiKhn = "https://knowledgebase.radisan.ir/api/";
  this.Root = "https://localhost:7072";

  this.APIRoot = "https://my.radisan.ir/api/api";
  // this.Root = "https://my.radisan.ir";

  //   this.APIRoot = window.location.origin + "/api";
  this.Root = window.location.origin;
}

var Config = new ConfigManager();
export default Config;
